export enum BENEFIT_GROUP_CATEGORY {
  FAMILIES = 'families',
  CHRONIC_CONDITIONS = 'chronicConditions',
  FERTILITY_CARE = 'fertilityCare',
}

export enum BENEFIT_ID {
  GOOGLE_PERFORMANCE = 'googlePerformance',
  LYRA_RESOURCE_COORDINATION = 'lyraResourceCoordination',
}

export enum BENEFITS_SECTION_ID {
  FEATURED = 'Featured',
  CORE_BENEFITS = 'CoreBenefits',
  SPECIALIZED_CARE = 'SpecializedCare',
  CURATED_FOR_YOU = 'CuratedForYou',
  MORE_BENEFITS = 'MoreBenefits',
}

export const LYRA_HUB_LINK = 'https://app.icas.health'
export const LYRA_ESSENTIALS_BENEFIT = 'Lyra Essentials'
